export const SET_VALUE = 'SET_VALUE';

interface formReducerInitialStateType {
    [key: string]: {
        [key: string]: string | { [key: string]: string };
    };
}

export const formReducerInitialState: formReducerInitialStateType = {};

export const formReducer = (state: formReducerInitialStateType, action: any) => {
    switch (action.type) {
        case SET_VALUE:
            const { formId, fieldId, value } = action.payload;
            return {
                ...state,
                [formId]: {
                    ...state[formId],
                    [fieldId]: value,
                },
            };
        default:
            throw new Error();
    }
};
